import React, { useEffect, useCallback } from 'react';
import { Route, Routes, useLocation } from 'react-router-dom';
import { ThemeProvider } from '@mui/material/styles';
import CssBaseline from '@mui/material/CssBaseline';
import '@fortawesome/fontawesome-free/css/all.min.css';
import theme from 'assets/theme';
import Presentation from 'layouts/pages/presentation';
import routes, { buttonRoutes } from 'routes';
import NotFound from './pages/NotFound';

const App = () => {
    const { pathname } = useLocation();

    // Scroll to top on route change
    useEffect(() => {
        document.documentElement.scrollTop = 0;
        document.scrollingElement.scrollTop = 0;
    }, [pathname]);

    const getRoutes = useCallback((allRoutes) => {
        return allRoutes.flatMap((route, index) => {
            if (route.collapse) {
                return getRoutes(route.collapse);
            }
            if (route.route) {
                return (
                  <Route
                    exact
                    path={route.route}
                    element={route.component}
                    key={route.key || `${route.route}-${index}`}
                  />
                );
            }
            return [];
        });
    }, []);

    const allAppRoutes = [...getRoutes(routes), ...getRoutes(buttonRoutes)];

    return (
      <ThemeProvider theme={theme}>
          <CssBaseline />
          <Routes>
              <Route path="/" element={<Presentation />} />
              {allAppRoutes}
              <Route path="*" element={<NotFound />} />
          </Routes>
      </ThemeProvider>
    );
};

export default App;
